import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { User } from '@rocksoft/security-sdk';

@Component({
  selector: 'era-security-user-list-item-ui',
  templateUrl: './user-list-item.component.html',
  styleUrls: ['./user-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, FaIconComponent],
})
export class UserListItemComponent {
  public readonly user = input<User>();
  public readonly isEditing = input<boolean>();
  public readonly deleteEvent = output<User>();

  delete(user: User): void {
    this.deleteEvent.emit(user);
  }
}
